import type { ComponentProps } from 'react'

import ExpenseDetailDialog from '../../components/ExpenseDetailDialog'

export default function ExpenseDetailMobilePage(props: ComponentProps<typeof ExpenseDetailDialog>) {
  return <ExpenseDetailDialog {...props} fullscreen />
}
